import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as auth from './redux/AuthRedux'
import { apiLogout } from '../../redux/api'
import { RootState } from '../../../setup'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useSetLang } from '../../../_metronic/i18n/Metronici18n'

export function Logout() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
   const setLang = useSetLang()
  const accessToken = useSelector((state: RootState) => state.auth.accessToken)

  useEffect(() => {
    if (!accessToken) {
      navigate('/auth/login')
      return
    }

    const logout = async () => {
      try {
        await apiLogout({ 'access-token': accessToken })
      } catch (error) {
        // console.error('Logout API failed:', error)
      } finally {
        localStorage.clear()
        dispatch(auth.actions.logout())
        setLang('en')
        navigate('/')
      }
    }

    logout()
  }, [accessToken, dispatch, navigate])

  return <div id="splash-screen" className="splash-screen">
    <img src={toAbsoluteUrl('/media/logos/iFleetcam_logo.png')} alt="iFleetcam" />
  </div>
}
